<i class="ti" [ngClass]="fromQuoteRequest ? 'ti-discount-check-filled' : 'ti-discount-check'" [style.font-size.px]="size"
    [style.color]="fromQuoteRequest ? '#008cf3' : '#6c757d'"
    [attr.aria-label]="fromQuoteRequest ? 'Review from a quote request' : 'Review from public page'">
</i>
